import React, {useContext} from "react"
import {List, ListItem, ListItemIcon, ListItemText} from "@mui/material"

import CartIcon from "./cartIcon.png"
import OrdersIcon from "./ordersIcon.png"
import CustomerIcon from "./customerIcon.png"
import DocumentIcon from "./documentIcon.png"
import SubscriptionIcon from "./subscriptionIcon.png"
import WixIcon from "./wix.png"
import vistaprintLogo from "../header/vistaprint.png"
import searchIcon from "./searchIcon.png"
import {useNavigate} from "react-router-dom"
//import history from "../../utils/history"
import getDigitalDashboardUrl from "../../services/subman/subscriptions"
import {getCustomerId, getTenantId} from "../../utils/Routes"
import {TenantsContext} from "../../contexts/TenantsContext"
import {makeStyles} from "tss-react/mui"

const useStyles = makeStyles()({
	list: {
		width: 250,
	},
	fullList: {
		width: "auto",
	},
})

interface SideBarProps {
	handler: any
}

function SideBar(props: SideBarProps) {
	const {classes} = useStyles()
	const {tenants} = useContext(TenantsContext)
	const navigate = useNavigate()
	async function handleClick(e: any) {
		if (e === "Subscriptions") {
			await getDigitalDashboardUrl(getCustomerId(), getTenantId(), tenants).then((url) => {
				window.open(url)
			})
		} else {
			navigate("/" + e + window.location.search, {replace: true})
		}
	}

	return (
		<div
			className={classes.list}
			role="presentation"
			onClick={props.handler(false)}
			onKeyDown={props.handler(false)}
		>
			<List>
				<ListItem>
					<img src={vistaprintLogo} width="auto" height="25" alt=""></img>
				</ListItem>
				<ListItem button key="Customers" onClick={() => handleClick("Customer-Search")}>
					<ListItemIcon>
						<img src={searchIcon} width="auto" height="25" alt=""></img>
					</ListItemIcon>
					<ListItemText primary="Search Customers" />
				</ListItem>
				<ListItem button key="CustomerDetails" onClick={() => handleClick("Customer-Details")}>
					<ListItemIcon>
						<img src={CustomerIcon} width="auto" height="25" alt=""></img>
					</ListItemIcon>
					<ListItemText primary="Customer Details" />
				</ListItem>
				<ListItem button key="Orders" onClick={() => handleClick("orders")}>
					<ListItemIcon>
						<img src={OrdersIcon} width="auto" height="25" alt=""></img>
					</ListItemIcon>
					<ListItemText primary="Orders" />
				</ListItem>
				<ListItem button key="Documents" onClick={() => handleClick("Documents")}>
					<ListItemIcon>
						<img src={DocumentIcon} width="auto" height="25" alt=""></img>
					</ListItemIcon>
					<ListItemText primary="Documents" />
				</ListItem>
				<ListItem button key="Cart" onClick={() => handleClick("Cart")}>
					<ListItemIcon>
						<img src={CartIcon} width="auto" height="25" alt=""></img>
					</ListItemIcon>
					<ListItemText primary="Cart" />
				</ListItem>
				<ListItem button key="Subscriptions" onClick={() => handleClick("Subscriptions")}>
					<ListItemIcon>
						<img src={SubscriptionIcon} width="auto" height="25" alt=""></img>
					</ListItemIcon>
					<ListItemText primary="Subscriptions" />
				</ListItem>
				<ListItem button key="wix" onClick={() => handleClick("wix")}>
					<ListItemIcon>
						<img src={WixIcon} width="auto" height="12" alt=""></img>
					</ListItemIcon>
					<ListItemText primary="Wix" />
				</ListItem>
			</List>
		</div>
	)
}

// export default TemporaryDrawer;
export default SideBar
